import React, { useState, useEffect } from "react";
import { exerciseUrls } from "../public/data.js";
import ExerciseVideo from "../components/Exercise/ExerciseVideo";

interface ExerciseProps {
  title: string;
  originalLinks: {
    url1: string;
    url2: string;
    url3: string;
    url4: string;
    audioSource: NodeRequire;
    title: string;
    level: string;
    apparatus: string; 
    props: string;
    body: string;
  };
}

const Exercise = ({ title, originalLinks }: ExerciseProps) => {

  return (
    <div id="individual">
      <ExerciseVideo originalLinks={originalLinks} />
    </div>
  );
};

export default Exercise;
